import React from 'react';
import { useTranslation } from 'react-i18next';
import useLocalizedNavigate from 'hooks/useLocalizedNavigate';
import { MenuIcon, CasinoIcon, RewardsIcon, ChatIcon } from 'components/icons';
import { show as showIntercom } from '@intercom/messenger-js-sdk';
import styles from './mobileFooter.module.scss';

interface MobileFooterProps {
  onMenuClick: () => void;
  activeItem: string;
  setActiveItem?: (item: string) => void;
  onVipClick: () => void;
}

const MobileFooter: React.FC<MobileFooterProps> = ({
  onMenuClick,
  activeItem,
  setActiveItem,
  onVipClick,
}) => {
  const navigate = useLocalizedNavigate();
  const { t } = useTranslation();

  const handleItemClick = (item: string, path?: string) => {
    setActiveItem?.(item);
    if (path) {
      navigate(path);
      window.scrollTo(0, 0);
    }
  };

  const handleChatClick = () => {
    setActiveItem?.('Chat');
    showIntercom();
  };

  return (
    <footer className={styles.mobileFooter}>
      <button className={styles.navItem} onClick={onMenuClick}>
        <MenuIcon width="24" height="24" />
        <span>{t('common.menu', t('nav.menu', 'Menu'))}</span>
      </button>

      <button
        className={`${styles.navItem} ${activeItem === 'Casino' ? styles.active : ''}`}
        onClick={() => handleItemClick('Casino', '/')}
      >
        <CasinoIcon width="24" height="24" />
        <span>{t('common.casino', t('header.casino', 'Casino'))}</span>
      </button>

      {/* <button
        className={`${styles.navItem} ${activeItem === 'Sports' ? styles.active : ''}`}
        onClick={() => handleItemClick('Sports', '/')}
      >
        <SportsIcon width="24" height="24" />
        <span>{t('common.sports', t('header.sports', 'Sports'))}</span>
      </button> */}

      <button
        className={`${styles.navItem} ${activeItem === 'VIP' ? styles.active : ''}`}
        onClick={() => {
          setActiveItem?.('VIP');
          onVipClick();
        }}
      >
        <RewardsIcon width="24" height="24" />
        <span>{t('common.rewards', t('header.rewards', 'Rewards'))}</span>
      </button>

      <button
        className={`${styles.navItem} ${activeItem === 'Chat' ? styles.active : ''}`}
        onClick={handleChatClick}
      >
        <ChatIcon width="24" height="24" />
        <span>{t('common.chat', t('nav.chat', 'Chat'))}</span>
      </button>
    </footer>
  );
};

export default MobileFooter;
